import Dom from '../base/mdom.js';
import wxBridge from '../jsbridge/jsbridge_login_queue.js';
import Gmsg from '../config/gmsg.js';

let exportData;
(function (win) {
    var FAIL_CALL_RET = -999;
    var mweixin = {};
    /* oGameData = {
         androiddownurl: "1",
         appid: "wx55e165cd33e436a1",
         gamename: "全民枪王",
         iosdownurl: "",
         ioslink: "",
         md5sum: "1",
         pkgname: "1",
         schemecall: "1",
         yyURL: "",
     }
     所有调用回调函数返回值说明：
        0   : 调用成功
        -999: 参数错误
     */

    var agent = Dom.window.navigator.userAgent,
        _isWechat = agent.indexOf('MicroMessenger') != -1,
        _isAndroid = /(Android)/i.test(agent),
        _downVerified = false,
        _wxVersion = getClientVersion(),
        _isDebug = location.search.indexOf('debug=2') != -1,
        _isiOS = /(iPhone|iPad|iPod|iOS)/i.test(agent) && !_isAndroid;
    win.tipsMsg = win.tipsMsg || {};
    win.gMsg = Gmsg.gMsg || {};

    function getQueryStr(name, str, context) {
        if( undefined === context ){
            context = window;
        }
        if(undefined === context.location){
            throw  'Illegal Context,Need context.location';
        }
        var _str = str || context.location.search;
        //先去除一下hash
        _str = ('' + _str).replace(/#(.*)$/g, '').replace(/&amp;/g, '&');
        var res = _str.match(new RegExp("[\?\&]" + name + "=([^\&]+)", "i"));
        if (res == null || res.length <= 1) {
            return "";
        }
    
        return res[1];
    }

    function initDownInternal(opt) {
        var t = bridgeReadyCall(initDownInternal, opt);
        opt = opt || win;
        if (!_isWechat || !opt.timestamp || !opt.noncestr || !opt.signature || !t) {
            return;
        }
        
        if (wxBridge) {
            wxBridge.verifyJsapi(wxBridge.apis, function (ret) {
                if (ret) {
                    _downVerified = true;
                }
            });
        }
        
    }

    function paramCallback(func, state) {
        if (func && typeof (func) == 'function') {
            func(state);
        }
    }

    //启动信息自动补全
    function autoFillAppItem(param){
        var map = {
            appid          : 'AppID',
            ioslink        : 'AppID',
            schemecall     : 'AppID',
            iosdownurl     : 'DownloadInfo.DownloadURL',
            pkgname        : 'PackageName',
            md5sum         : 'DownloadInfo.AndroidApkMd5',
            androiddownurl : 'DownloadInfo.DownloadURL',
        };
        for(var k in map){
            var obj = map[k].indexOf('.') != -1 ? param.DownloadInfo||{} : param;
            var key = map[k].indexOf('.') != -1 ? map[k].split('.')[1]   : map[k]; 
            if(!(k in param) && map[key] in obj && obj[map[key]]){
                param[k] = obj[map[key]] 
                    + ((k=='ioslink'||k=='schemecall')?'://':'');
            }
        }
        return param;
    }

    function getClientVersion() {
        var mat = (Dom.window.navigator.userAgent || Dom.window.navigator.wxuserAgent || str).match(/MicroMessenger\/([\d\.]+)/i),
            version = '',
            udots = [1000, 100, 1],
            uversion = 0;
        if (mat && mat.length > 1) {
            version = mat[1];
        }
        version = version.split('.').slice(0, 3);
        for (var i = 0, il = version.length; i < il; i++) {
            var t = parseInt(version[i].substr(0,2));
            if (!isNaN(t)) {
                uversion += t * udots[i];
            }
        }
        return uversion;
    }

    function getLaunchApiName(){
        return _wxVersion > 6504 ? 'launchApplication' : 'launch3rdApp' ;
    }

    function bridgeReadyCall(func, args) {
        func.retryCnt = func.retryCnt || 1;
        if (!_isWechat || func.retryCnt > 100) {
            mweixin.log('bridgeReadyCall retry count exceed', func.retryCnt, func, args);
            return false;
        }
        if (_isWechat && !win.WeixinJSBridge) {
            func.retryCnt++;
            clearTimeout(func.retryTimeout);
            func.retryTimeout = setTimeout(function () {
                func.apply(null, args);
            }, 100);
            return false;
        }
        return true;
    }

    function monitorAppDownloadState(param, cbk) {
        if (_wxVersion > 6300) {
            return;
        }
        if (!param || !param.appid) {
            if (typeof (cbk) == 'function') {
                cbk(FAIL_CALL_RET);
            }
            return;
        }
        clearInterval(monitorAppDownloadState[param.appid]);
        monitorAppDownloadState[param.appid] = setInterval(function () {
            if (!win.WeixinJSBridge) {
                return;
            }
            mweixin.app.isDownloaded(param, function (ret) {
                mweixin.log && mweixin.log(param.appid, 'monitorAppDownloadState->mweixin.app.isDownloaded->ret->' + ret);
                var state = '',
                    txt = '';
                if (ret == 0) {
                    clearInterval(monitorAppDownloadState[param.appid]);
                    state = 'downloaded';
                    txt = tipsMsg.installText || gMsg.installText;
                    if (!cbk) {
                        mweixin.app.installApp(param, cbk);
                    }
                } else if (ret == 2) {
                    state = 'downloaded';
                    txt = tipsMsg.downloadingText || gMsg.downloadingText;
                }
                if (param.btns && state) {
                    for (var i = 0, il = param.btns.length; i < il; i++) {
                        param.btns[i].state = state;
                        param.btns[i].innerHTML = txt;
                    }
                }
            });
        }, 1000);
    }

    function monitorAppInstallState(param, cbk) {
        if (_wxVersion > 6300) {return;}
        if (!param || !param.appid) {
            if (typeof (cbk) == 'function') {cbk(FAIL_CALL_RET);}
            return;
        }
        clearInterval(monitorAppInstallState[param.appid]);
        //没有按钮，不检测状态，直接退出
        if (!param.btns || param.btns.length == 0) {return;}
        //ios一刀切了，不检查游戏状态了
        if (_isiOS) {
            var txt = tipsMsg.iosStartText || tipsMsg.startText || gMsg.startText;
            var state = 'installed';
            if (param.btns) {
                for (var i = 0, il = param.btns.length; i < il; i++) {
                    param.btns[i].state = state;
                    param.btns[i].innerHTML = txt;
                }
            }
            if (typeof (cbk) == 'function') {cbk(param, 0);}
            return;
        }
        monitorAppInstallState[param.appid] = setInterval(function () {
            if (!win.WeixinJSBridge) {return; }
            mweixin.app.isAppInstalled(param, function (ret) {
                //console.log('monitorAppInstallState->ret->' + ret);
                var txt   = ret == 0 
                        ? (tipsMsg.startText||gMsg.startText)
                        : ( ret == 1 
                            ? (tipsMsg.upgradeText||gMsg.upgradeText || '更新')
                            : (tipsMsg.downloadText||gMsg.downloadText)
                          ),
                    state = ret == 0 ? 'installed' : '';
                // new Image().src = '/?ret = ' + ret;
                if (ret == 0) {
                    clearInterval(monitorAppInstallState[param.appid]);
                    if (param.btns) {
                        for (var i = 0, il = param.btns.length; i < il; i++) {
                            param.btns[i].state = state;
                            param.btns[i].innerHTML = txt;
                        }
                    }
                    if (typeof (cbk) == 'function') {cbk(param, ret);}
                } else if (ret == FAIL_CALL_RET) {
                    clearInterval(monitorAppInstallState[param.appid]);
                } else {
                    mweixin.app.isDownloaded(param, function (ret) {
                        mweixin.log(param.appid, 'monitorAppDownloadState->mweixin.app.isDownloaded->ret->' + ret);
                        if (param.onlyOne) {
                            clearInterval(monitorAppInstallState[param.appid]);
                            delete param.onlyOne;
                        }
                        var states = '',
                            text   = '';
                        if (ret == 0) {
                            states = 'downloaded';
                            text   = tipsMsg.installText || gMsg.installText;
                        } else if (ret == 2) {
                            states = 'downloaded';
                            text   = tipsMsg.downloadingText || gMsg.downloadingText;
                        } else {
                            states = 'notdownload';
                            text   = tipsMsg.downloadText || gMsg.downloadText;
                        }
                        if(txt == tipsMsg.upgradeText || txt == gMsg.upgradeText || txt == '更新'){
                            text = txt;
                        }
                        if (param.btns && states) {
                            for (var i = 0, il = param.btns.length; i < il; i++) {
                                param.btns[i].state = states;
                                param.btns[i].innerHTML = text;
                            }
                        }
                        paramCallback(cbk, ret);
                    });
                }
            });
        }, 1000);
    }

    function popInvalid(param) {
        mweixin.log(param.appid, 'mweixin.app.isAppInstalled->installApp->param.yyURL');
        var msg = tipsMsg.androidnotreadyText || gMsg.androidnotreadyText,
            btn = param.yyURL ? 'twoBtn' : 'oneBtn';
        if (_isiOS) {
            msg = tipsMsg.iosnotreadyText || gMsg.iosnotreadyText;
        }
        if (param.yyURL) {
            if (_isiOS) {
                msg = tipsMsg.iosjumpText     || "游戏IOS版暂未上架，马上去预约";
            } else {
                msg = tipsMsg.androidjumpText || "游戏Android版暂未上架，马上去预约";
            }
        }
        clearInterval(monitorAppDownloadState[param.appid]);
        clearInterval(monitorAppInstallState[param.appid]);
        mweixin.log(param.appid, 'mweixin.app.isAppInstalled->installApp->alert');
        import('../common/uiutil.popup.src.js')
        .then(function(cpt) {
            win.UI = cpt.default;
            UI.alert(msg, {
                style     : btn,
                confirmCb : function () {
                    if (param.yyURL) {location.href = param.yyURL;}
                }
            });
        });
    }

    function gameAllInOne(param, cbk) {
        //只有H5游戏, 则原生就不动了
        if(goH5GamePage(param, cbk)){return;}
        //有原生游戏或者是混合类型, 则启动原生失败, 直接跳H5游戏
        mweixin.app.isAppInstalled(param, function (ret) {
            mweixin.log(param.appid, 'gAiO->isAppInstalled->ret->' + ret);
            if (ret == 0) {
                //单机专区特有逻辑,启动不了游戏, 后台增加权限校验位, 后面一定会改, 可能会去掉
                if(_isAndroid && param.donotAutoDownload){

                    import('../common/uiutil.popup.src.js')
                    .then(function(cpt) {
                        var msg = "请从桌面启动";
                        win.UI = cpt.default;
                        UI.alert(msg);
                    });
                    return;
                }
                mweixin.app.launchApp(param, function (ret) {
                    if (ret == 0) {
                        if (typeof (cbk) == 'function') {cbk(6);}
                    } else {
                        // 互通型APP, 原生/H5共存, 原生拉起失败, 尝试跳H5
                        if(param.AppType == 2){
                            param.AppType = 1;
                            if(goH5GamePage(param, cbk)){return;}
                        }

                        // 7.0以后的自动失败拉起appstore，不需要自己做下载动作
                        if ( ret == 1 ) {
                            if (typeof (cbk) == 'function') {cbk(3);}
                            return;
                        }
                        
                        mweixin.app.addDownloadTask(param, function (ret) {
                            mweixin.log(param.appid, 'gAiO->isAppInstalled->_isiOS->addDownloadTask->ret->' + ret);
                            if(ret == FAIL_CALL_RET){ //参数不全
                                popInvalid(param);
                                if (typeof(cbk)=='function'){cbk(FAIL_CALL_RET);}
                                return;
                            }
                            if (ret == 0){
                                if (typeof (cbk) == 'function') {cbk(3);}
                            }
                            monitorAppInstallState(param, function (ret) {
                                mweixin.log(param.appid, 'gAiO->_isiOS->monitorAppInstallState->ret->' + ret);
                            });
                        });
                    }
                    mweixin.log(param.appid, 'gAiO->isAppInstalled->launchApp->ret->' + ret);
                });
            } else {
                // 原生没安装, 且有H5游戏页, 尝试跳H5
                if(param.AppType == 2){
                    param.AppType = 1;
                    if(goH5GamePage(param, cbk)){return;}
                }
                if (_isiOS) {
                    if (ret == FAIL_CALL_RET) {
                        popInvalid(param);
                        if (typeof (cbk) == 'function') {cbk(FAIL_CALL_RET);}
                        return;
                    }
                    
                    mweixin.app.addDownloadTask(param, function (ret) {
                        
                        mweixin.log(param.appid, 'gAiO->isAppInstalled->_isiOS->addDownloadTask->ret->' + ret);
                        monitorAppInstallState(param, function (ret) {
                            mweixin.log(param.appid, 'gAiO->_isiOS->monitorAppInstallState->ret->' + ret);
                        });
                        if (ret == 0){
                            if (typeof (cbk) == 'function') {cbk(3);}
                        }
                    });
                } else {
                    if (ret == FAIL_CALL_RET) {
                        popInvalid(param);
                        if (typeof (cbk) == 'function') {
                            cbk(FAIL_CALL_RET);
                        }
                        return;
                    }
                    var outRet = ret;
                    mweixin.log(param.appid, 'gAiO->isAppInstalled-> ' + ret + '->_isAndroid->isDownloaded');
                    mweixin.app.isDownloaded(param, function (ret) {
                        mweixin.log(param.appid, 'gAiO->isAppInstalled->_isAndroid->isDownloaded->ret->' + ret);
                        if (ret == 0 && outRet != 17) {
                            if (typeof (cbk) == 'function') {
                                cbk(11);
                            }
                            mweixin.app.installApp(param, function (ret) {
                                mweixin.log(param.appid, 'gAiO->isAppInstalled->_isAndroid->isDownloaded->installApp->ret->' + ret);
                                //安装失败了
                                if (ret == -1) {
                                    gameAllInOne(param, cbk);
                                }
                            });
                        } else if (ret == 2) {
                            //下载中,不再上报
                            monitorAppDownloadState(param);
                            // if (typeof (cbk) == 'function') {
                            //     cbk(outRet==17 ? 17 : 3);
                            // }
                        } else if (ret < 0 || outRet == 17) {
                            mweixin.log(param.appid, 'gAiO->isAppInstalled->fail->isDownloaded->fail->ret->-1->addDownloadTask');
                            mweixin.app.addDownloadTask(param, function (ret) {
                                if (ret == 0) {
                                    monitorAppDownloadState(param);
                                    wxBridge.invoke('queryDownloadTask', {
                                        appid: param.appid
                                    }, function (res) {
                                        param.download_id = res.download_id;
                                    });
                                    
                                    if (typeof (cbk) == 'function') {
                                        cbk(outRet==17 ? 17 : 3);
                                    }
                                    
                                }
                                mweixin.log(param.appid, 'gAiO->isAppInstalled->fail->isDownloaded->fail->ret->-1->addDownloadTask->ret=' + ret);
                            });
                            
                            // if (typeof (cbk) == 'function') {
                            //     cbk(outRet==17 ? 17 : 3);
                            // }
                            
                        }
                    });
                }
            }
        });
    }

    function createNamespace(_sName, context) {
        var _oArr = _sName.split('.'),
            _oSpace = context || window,
            _sName;
        for (var i in _oArr) {
            _sName = _oArr[i];
            !_oSpace[_sName] && (_oSpace[_sName] = {});
            _oSpace = _oSpace[_sName];
        }
        return _oSpace;
    }
    /*
        APP_TYPE_NATIVE        = 0,  // 原生App
        APP_TYPE_H5            = 1,  // 纯H5 App
        APP_TYPE_NATIVE_AND_H5 = 2,  // H5互通游戏

        "HVAppInfo": {
            "AppID": "wxf926d9f9ca8aeee2",
            "LaunchUrl": "www.qq.com"
        },
     */
    function openCustomWebview(api, params){
        wxBridge.verifyJsapi(wxBridge.apis, function(boo){
            wxBridge.invoke(api, params, function(res){
                res = res || {};
                mweixin.log(api + ' res', encodeURIComponent(JSON.stringify(params)), encodeURIComponent(JSON.stringify(res)));
                var msg = res.err_msg || res.errMsg || '';
                mweixin.log('open ' + api + ' ret ', params, res);
                if(msg.indexOf(':ok') == -1){
                    openExterWebview(params);
                }
            });
        });
    }

    function openExterWebview(params){
        if (_isWechat) {
            wxBridge.verifyJsapi(wxBridge.apis, function(boo){
                wxBridge.invoke('openUrlWithExtraWebview', {url:params.url,openType:1}, function (res) {
                    res = res || {};
                    mweixin.log('openUrlWithExtraWebview res', encodeURIComponent(JSON.stringify(param)), encodeURIComponent(JSON.stringify(res)));
                    var msg = res.err_msg || res.errMsg || '';
                    mweixin.log('open openUrlWithExtraWebview ret ', params, res);
                    if (msg.indexOf(':ok') == -1) {
                        location.href = params.url;
                    }
                });
            });
        }else{
            location.href = params.url;
        }
    }

    function goH5GamePage(param, cbk){
        mweixin.log('goH5GamePage', encodeURIComponent(JSON.stringify(param)));
        if(
            'AppType' in param && param.AppType == 1 
            && param.HVAppInfo && param.HVAppInfo.LaunchUrl
        ){
            var valid_api = _wxVersion >= 6313 && _isiOS ? 'openWKWebView' 
                : (_wxVersion > 6500 && _isAndroid ? 'openCustomWebview' : false);
            var _param = {
                    orientation : param.orientation || '',
                    fullscreen  : 'fullscreen' in param ? (param.fullscreen ? "true": "false") : "false",
                    url         : param.HVAppInfo.LaunchUrl.split('#')[0]
                };
            if(_isAndroid){
                if('closeCurrent' in param){
                    _param.finish_recent_webview = param.closeCurrent ? "1" : "0";
                }
                if('noSwipe' in param){
                    _param.disable_swipe_back = param.noSwipe ? "1" : "0";
                }
            }
            _param.url = _param.url.replace(/^\s+/g,'').replace(/\s+$/g,'');
            mweixin.log('open h5 game', valid_api, encodeURIComponent(JSON.stringify(_param)));
            paramCallback(cbk, 70);
            if(valid_api){
                openCustomWebview(valid_api, _param);
                return true;
            }else{
                openExterWebview(_param);
            }
        }
        return false;
    }

    mweixin.build = function (_sName, _oData) {
        var _oFunc = null,
            _mbiOS = /(iPhone|iPad|iPod|iOS)/i.test(Dom.window.navigator.userAgent),
            _mbAndroid = /(Android)/i.test(Dom.window.navigator.userAgent),
            _nIndex = _sName.lastIndexOf('.'),
            _oNS = createNamespace(_sName.substring(0, _nIndex), mweixin);
        if (_oData.iOS && _mbiOS) {
            _oFunc = _oData.iOS;
        } else if (_oData.android && _mbAndroid) {
            _oFunc = _oData.android;
        } else {
            _oFunc = function () {};
            //alert('get os error : ' + _sName);
        }
        _oNS[_sName.substring(_nIndex + 1)] = _oFunc;
    };

    mweixin.log = function () {
        if (_isDebug) {new Image().src = '/?' + JSON.stringify(arguments);}
    };

    mweixin.build("app.isDownloaded", {
        iOS: function () {},
        android: function (param, cbk) {
            wxBridge.invoke("queryDownloadTask", {
                appid: param.appid //用于和原生打通,原生的下载了游戏,在h5端也可以查询到下载了
            }, function (res) {
                var _smsg = (res && res.state) || '',
                    state = -2;
                if (_smsg && _smsg.indexOf('_succ') != -1) {
                    state = 0;
                } else if (_smsg && _smsg.indexOf('ing') != -1) {
                    state = 2;
                } else if (_smsg && _smsg.indexOf('_fail') != -1) {
                    state = -1;
                } else {
                    state = -2;
                }
                if ('download_id' in res) {
                    param.download_id = res.download_id;
                }
                paramCallback(cbk, state);
            });
        }
    });

    mweixin.build("app.isAppInstalled", {
        iOS: function iOSisAppInstalled(param, cbk) {
            mweixin.log(param.appid, 'mweixin.app.isAppInstalled->installApp->!param.ioslink=' + !param.ioslink);
            if (!param.ioslink || !param.ioslink) {
                paramCallback(cbk, FAIL_CALL_RET);
                mweixin.log(param.appid, "err: isAppInstalled,iOS , no Param ioslink");
                return;
            }
            if (!_isWechat || !bridgeReadyCall(iOSisAppInstalled, [param, cbk])) {
                mweixin.log(param.appid, 'mweixin.app.isAppInstalled->installApp->!_isWechat||!bridgeReadyCall(arguments.callee, [param, cbk])');
                return;
            }
            paramCallback(cbk, 0, {});
        },
        android: function androidisAppInstalled(param, cbk) {
            if (!param.pkgname || !param.md5sum || !param.androiddownurl) {
                mweixin.log(param.appid, "err: isAppInstalled,android , no Param pkgname");
                paramCallback(cbk, FAIL_CALL_RET);
                return;
            }
            if (!_isWechat || !bridgeReadyCall(androidisAppInstalled, [param, cbk])) {
                return;
            }
            wxBridge.invoke('getInstallState', {
                'packageName': param.pkgname
            }, function (res) {
                var installed = 1;
                //console.log(res, 'WeixinJSBridge.invoke-> Android ->getInstallState->res=' + JSON.stringify(res));
                if (res && (res.err_msg || res.errMsg)) {
                    installed = (res.err_msg || res.errMsg).indexOf(':yes') > -1 ? 0 : 1;
                    if(installed==0){
                        var ver = parseInt((res.err_msg||res.errMsg).split(':yes_')[1]);
                        var _v  = parseInt(param.version || '0');
                        if(_v && _v > ver){
                            installed = 17;
                        }
                    }
                }
                paramCallback(cbk, installed, res);
            });
        }
    });

    mweixin.build('app.addDownloadTask', {
        iOS: function iOSCall(param, cbk) {
            if (!param || !param.iosdownurl) {
                paramCallback(cbk, FAIL_CALL_RET);
                mweixin.log(param.appid, "err: addDownloadTask, iOS, no Param iosdownurl");
                return;
            }
            mweixin.log(param.appid, "app.addDownloadTask !_isWechat || !bridgeReadyCall(arguments.callee, [param, cbk])" , !_isWechat, !bridgeReadyCall(iOSCall, [param, cbk]) );
            if (!_isWechat || !bridgeReadyCall(iOSCall, [param, cbk])) {
                return;
            }
            var isFromWeappEntry = param.isFromWeappEntry;
            /**
             * 微信版本大于6.5.05，并且不是从小程序跳转过来的。
             * 才使用 downloadAppInternal，否则使用location.href去appstroe下载。
             */
            if(_wxVersion > 6505 && !isFromWeappEntry ){
                mweixin.log(param.appid, param.iosdownurl, "before : wxBridge.verifyJsapi3");
                //wxBridge.verifyJsapi(wxBridge.apis, function(boo){
                    mweixin.log(param.appid, param.iosdownurl, "before downloadAppInternal3:");
                    wxBridge.invoke('downloadAppInternal', {
                        appUrl: param.iosdownurl
                    }, function(rs){
                        mweixin.log(param.appid, param.iosdownurl, "addDownloadTask downloadAppInternal: ", JSON.stringify(rs));
                        var msg = rs.err_msg || rs.errMsg || '';
                        if(msg.indexOf(':ok')==-1){
                            location.href = param.iosdownurl;
                        }
                    });
                //});
            }else{
                mweixin.log('app.addDownloadTask->wxBridge.verifyJsapi-> wechat version error', wxBridge.apis, param);
                location.href = param.iosdownurl;
            }
            paramCallback(cbk, 0);
        },
        android: function androidCall(param, cbk) {
            if (!param || !param.pkgname || !param.androiddownurl || !param.md5sum || !param.appid) {
                paramCallback(cbk, FAIL_CALL_RET);
                mweixin.log(param.appid, "err: addDownloadTask, android, no Param pkgname or androiddownurl or md5sum or appid");
                return;
            }
            if (!_isWechat || !bridgeReadyCall(androidCall, [param, cbk])) {
                return;
            }
            if(param.forceYYB){
                param.url = 'https://a.app.qq.com/o/simple.jsp?pkgname=' + param.pkgname;
                openExterWebview(param, function(){paramCallback(_cbk, 0);});
                return;
            }
            function downGame(_param, _cbk){
                var api = _wxVersion > 6506 ? 'addDownloadTaskStraight' : 'addDownloadTask';

                // 默认为1，走CDN下载，add by zijianyang 2018/05/28
                var downloader_type = _param.downloadertype !== undefined ? _param.downloadertype : 1; 
                var _game_info = {
                    task_name    : _param.appname || _param.pkgname,
                    package_name : _param.pkgname,
                    task_url     : _param.androiddownurl,
                    file_md5     : _param.md5sum,
                    appid        : _param.appid, //此参数为下载进度条调试用,后期可能会放开使用,先放着
                    scene	     : _param.scene,        
                    extInfo      : _param.extInfo || encodeURIComponent(JSON.stringify({
                        gameid  : _param.appid,
                        noticeid: _param.noticeid || getQueryStr('noticeid'),
                        actid   : _param.actid    || getQueryStr('actid'),
                        ssid    : _param.ssid     || getQueryStr('ssid'),
                        abt     : _param.abt      || getQueryStr('abt'),
                        url     : location.href.replace(/&?pass_ticket=[^&]*/, '')
                                                .replace(/&?uin=[^&]*/, '')
                                                .replace(/&?key=[^&]*/, '')
                                                .replace(/&?abtest_cookie=[^&]*/, '')
                    })),
                    downloader_type : downloader_type
                };
                if (_param.androidpkgsize){
                    _game_info.task_size = _param.androidpkgsize;
                }
                if (_param.alternativeurl){
                    _game_info.alternative_url = _param.alternativeurl;
                }

                if(_param.use_downloader_widget ){
                    _game_info.use_downloader_widget = _param.use_downloader_widget;
                }
                mweixin.log(param.appid, 'mweixin.app.addDownloadTask->_game_info=' + JSON.stringify(_game_info));

                wxBridge.invoke(api , _game_info , function (res) {
                    mweixin.log(param.appid, 'mweixin.app.addDownloadTask->res=' + JSON.stringify(res));

                    if (res) {
                        if ((res.err_msg || res.errMsg).indexOf(":ok") > -1) {
                            paramCallback(_cbk, 0);
                            monitorAppDownloadState(_param);
                        } else {
                            paramCallback(_cbk, -1);
                        }
                    }else{
                        paramCallback(_cbk, -1);
                    }
                });
            }
            
            if(_wxVersion > 6506){
                //wxBridge.verifyJsapi(wxBridge.apis, function(boo){
                    downGame(param, cbk);
                //});
            }else{
                downGame(param, cbk);
            }
        }
    });

    mweixin.build('app.installApp', {
        iOS: function (url, cbk) {},
        android: function androidInstallApp(param, cbk) {
            if (!param || !param.pkgname || !param.androiddownurl || !param.md5sum || !param.appid) {
                paramCallback(cbk, FAIL_CALL_RET);
                mweixin.log(param.appid, "err: addDownloadTask, android, no Param pkgname or androiddownurl or md5sum or appid");
                return;
            }
            if (!_isWechat || !bridgeReadyCall(androidInstallApp, [param, cbk])) {
                return;
            }
            wxBridge.invoke("installDownloadTask", {
                download_id: param.download_id
            }, function (res) {
                mweixin.log(param.appid, 'mweixin.app.installApp->installDownloadTask->res=' + JSON.stringify(res));
                if ((res.err_msg || res.errMsg).indexOf(":fail") != -1) {
                    paramCallback(cbk, -1);
                } else {
                    if (param.btns) {
                        for (var i = 0, il = param.btns.length; i < il; i++) {
                            param.btns[i].state = 'installing';
                            param.btns[i].innerHTML = tipsMsg.installText || gMsg.installText;
                        }
                    }
                    paramCallback(cbk, 0);
                }
            });
            monitorAppInstallState(param);
        }
    });

    mweixin.build('app.launchApp', {
        iOS: function iOSLaunchApp(param, cbk) {
            if (!param || !param.appid) {
                mweixin.log(param.appid, "err: launchApp, iOS, no Param appid");
                paramCallback(cbk, FAIL_CALL_RET);return;
            }
            if (!_isWechat || !bridgeReadyCall(iOSLaunchApp, [param, cbk])) {
                return;
            }
            if(goH5GamePage(param, cbk)){return;}
            mweixin.log('wxBridge.apis->', wxBridge.apis);
            wxBridge.invoke(getLaunchApiName(), {
                showLaunchFailToast : false,
                appID               : param.appid,
                extInfo             : param.extInfo    || "WX_GameCenter",
                messageExt          : param.messageExt || "WX_GameCenter",
                installSchemeUrl    : param.iosdownurl || '',
                installAction       : 1
            }, function (res) {
                mweixin.log(param.appid, "info: iOS " + getLaunchApiName() + ' ' + JSON.stringify(res));
                // { err_msg : "launch_3rdApp:fail" }
                // alert(JSON.stringify(res));
                if ((res.err_msg || res.errMsg).indexOf(':ok') == -1) {
                    if (!param.ioslink) {
                        mweixin.log(param.appid, "err: launchApp, iOS, no Param ioslink");
                        paramCallback(cbk, FAIL_CALL_RET);
                        return;
                    }
                    paramCallback(cbk, -1);
                } else {
                    if ( res.launchInstallResult && res.launchInstallResult.indexOf('ok') != -1 ) {
                        paramCallback(cbk, 1);
                    } else {
                        paramCallback(cbk, 0);
                    }
                    
                }
            });
        },
        android: function androidLaunchApp(param, cbk) {
            if (!param || !param.appid) {
                mweixin.log(param.appid, "err: launchApp, android, no Param appid");
                paramCallback(cbk, FAIL_CALL_RET);
                return;
            }
            if (!_isWechat || !bridgeReadyCall(androidLaunchApp, [param, cbk])) {
                return;
            }
            wxBridge.invoke(getLaunchApiName() , {
                appID               : param.appid,
                showLaunchFailToast : false,
                messageExt          : param.messageExt || "WX_GameCenter",
                extInfo             : param.messageExt || "WX_GameCenter"
            }, function (res) {
                mweixin.log(param.appid, "info: Android " + getLaunchApiName() + ' ' + JSON.stringify(res));
                if ((res.err_msg || res.errMsg).indexOf(':ok') == -1) {
                    if (!param.schemecall) {
                        mweixin.log(param.appid, "err: launchApp, android, no Param schemecall");
                        paramCallback(cbk, FAIL_CALL_RET);
                        return;
                    }
                    window.location = param.schemecall;
                    paramCallback(cbk, 0);
                } else {
                    paramCallback(cbk, 0);
                }
            });
        }
    });

    mweixin.build('app.allinone', {
        iOS     : gameAllInOne,
        android : gameAllInOne
    });

    mweixin.build('app.popInvalid',{
        iOS     : popInvalid,
        android : popInvalid
    });

    mweixin.build('app.goH5GamePage',{
        iOS     : goH5GamePage,
        android : goH5GamePage
    });

    mweixin.build('app.autoFillAppItem',{
        iOS     : autoFillAppItem,
        android : autoFillAppItem
    });

    win.monitorAppInstallState = monitorAppInstallState;
    win.monitorAppDownloadState = monitorAppDownloadState;
    win.initDownInternal = initDownInternal;
    initDownInternal();
    exportData = mweixin;
})(Dom.window || window, document);

export default exportData;
//  usage:

// var oGameData = {
//     "gamename"       : "全民飞机大战",
//      // 可选参数
//      "AppType"       : 0,  // 0/1/2  //可选
//      "HVAppInfo"     : {
//              "AppID"     : "wxf926d9f9ca8aeee2",
//              "LaunchUrl" : "www.qq.com"
//      },
//     "appid"          : "wx47a71dd8a1875943",
//     "ioslink"        : "wx47a71dd8a1875943://",
//     "iosdownurl"     : "https://itunes.apple.com/cn/app/id731871690",
//     "schemecall"     : "webwx47a71dd8a1875943://",
//     "pkgname"        : "com.tencent.feiji",
//     "androiddownurl" : "http://dldir1.qq.com/mmopen/IEGgames/10000145_wefly_1.0.29.30_android.apk",
//     "androidpkgsize" : 479105840,
//     "alternativeurl" : "https://dldir1.qq.com/mmopen/IEGgames/10000145_wefly_1.0.29.30_android.apk",
//     "downloadertype" : 1,
//     "yyURL"          : "", //如果未上线，跳转到指定地址
//     onlyOne          : 0/1  //monitorXXX函数调用时，只更新一次状态，不监控后续动作
//     "md5sum"         : "e8b70df6e48635e54a5a490ed5f2d5f2",
//     "btns"           : [document.getElementById('game_Btn1'), document.getElementsByClassName('game-btn')[0]]
// };
// mweixin.app.allinone(oGameData); //点击时候调用
// monitorAppInstallState(oGameData); //用于游戏相关按钮文字状态更新
// monitorAppDownloadState(oGameData); //用于开始下载游戏后，对游戏相关按钮的状态更新
